import { useEffect, useRef } from 'react';
import styles from './EditableCell.module.css';

interface EditableCellProps {
  value: string;
  isEditing: boolean;
  name: string;
  onNameChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const EditableCell = ({
  value,
  isEditing,
  name,
  onNameChange,
  onSave,
  onCancel
}: EditableCellProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);

  if (!isEditing) return <span>{value}</span>;

  return (
    <input
      ref={inputRef}
      className={styles.input}
      type="text"
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onSave();
        else if (e.key === 'Escape') onCancel();
      }}
    />
  );
};
